"use strict";

var _interopRequireDefault = require("/Users/vagrant/git/node_modules/@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/web.dom.iterable");

require("regenerator-runtime/runtime");

var _asyncToGenerator2 = _interopRequireDefault(require("/Users/vagrant/git/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator"));

require("core-js/modules/es6.function.name");

var _apolloClient = require("@/apollo/apolloClient");

var _bulletinQuery = require("@/apollo/queries/bulletin-query");

var _bulletinMutation = require("@/apollo/mutations/bulletin-mutation");

var _auth = require("../../utils/auth");

var _moment = _interopRequireDefault(require("moment"));

var state = {
  bulletins: [],
  situation: [{
    id: 0,
    name: 'アプリへ公開する',
    val: 'now()'
  }, {
    id: 1,
    name: '管理サイトに下書き保存',
    val: null
  }],
  page_count: 0,
  page_total: 0,
  searchText: '',
  bulletinCategories: [],
  category_id: null,
  setOptionValue: null,
  // / 1 ドロップダウンボックス, 2 ドロップダウン検索, 3 カテゴリー一覧
  bulletinById: []
};
var mutations = {
  CREATE_BULLETIN_LIST: function CREATE_BULLETIN_LIST(state, bulletin) {
    state.bulletins = bulletin.map(function (item) {
      if (item.publish_at) {
        item.publish_at = (0, _moment.default)(String(item.publish_at)).format('YYYY年MM月DD日 HH:mm');
      }

      if (item.category) {
        item.category = item.category.name;
      } else {
        item.category = '';
      }

      if (item.bulletin_surveys) {
        if (item.bulletin_surveys.length !== 0) {
          item.bulletin_survey = '有り';
        }
      } else {
        item.bulletin_survey = '';
      }

      if (item.user) {
        if (item.user.name && item.user.last_name) {
          item.name = item.user.last_name + ' ' + item.user.name;
        } else item.name = '';
      } else item.name = '';

      return item;
    });
  },
  CREATE_BULLETIN_CATEGORIES_LIST: function CREATE_BULLETIN_CATEGORIES_LIST(state, bulletinCategoryList) {
    if (!bulletinCategoryList) {
      if (bulletinCategoryList.length === 0) {
        return;
      }

      return;
    }

    function customNameCategory(nameInput) {
      return bulletinCategoryList.unshift({
        id: null,
        name: nameInput
      });
    }

    if (bulletinCategoryList) {
      if (bulletinCategoryList.length !== 0) {
        switch (state.setOptionValue) {
          case 1:
            customNameCategory('');
            break;

          case 2:
            customNameCategory('全てのカテゴリー');
            break;

          default:
        }
      }
    }

    state.bulletinCategories = bulletinCategoryList;
  },
  CREATE_BULLETIN_BY_ID: function CREATE_BULLETIN_BY_ID(state, data) {
    state.bulletinById = data;
  },
  setBulletinCount: function setBulletinCount(state, val) {
    state.page_count = val;
  },
  setSearchText: function setSearchText(state, val) {
    state.searchText = val;
  },
  setCategoryId: function setCategoryId(state, val) {
    state.category_id = val;
  },
  setOptionValue: function setOptionValue(state, val) {
    state.setOptionValue = val;
  }
};
var actions = {
  getBulletinList: function () {
    var _getBulletinList = (0, _asyncToGenerator2.default)(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee(_ref) {
      var commit, searchText, res;
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              commit = _ref.commit;
              searchText = null;

              if (state.searchText) {
                searchText = state.searchText.trim();
              }

              state.page_size = 30;
              _context.next = 6;
              return _apolloClient.apolloClient.query({
                query: _bulletinQuery.GET_BULLETINS,
                variables: {
                  keyword: searchText,
                  page_limit: state.page_size,
                  page_offset: state.page_size * state.page_count,
                  categoryId: state.category_id
                }
              });

            case 6:
              res = _context.sent;

              if (res.data) {
                state.page_total = res.data.bulletin_count.aggregate.count === 0 ? 0 : Math.ceil(res.data.bulletin_count.aggregate.count / state.page_size) - 1;
              }

              commit('CREATE_BULLETIN_LIST', res.data.bulletin);

            case 9:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    function getBulletinList(_x) {
      return _getBulletinList.apply(this, arguments);
    }

    return getBulletinList;
  }(),
  getBulletinById: function () {
    var _getBulletinById = (0, _asyncToGenerator2.default)(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee2(_ref2) {
      var commit, idBulletin, res;
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              commit = _ref2.commit;
              _context2.next = 3;
              return (0, _auth.getIdEditPage)();

            case 3:
              idBulletin = _context2.sent;
              _context2.next = 6;
              return _apolloClient.apolloClient.query({
                query: _bulletinQuery.GET_BULLETIN_BY_ID,
                variables: {
                  id: idBulletin
                }
              });

            case 6:
              res = _context2.sent;
              commit('CREATE_BULLETIN_BY_ID', res.data.bulletin);

            case 8:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    function getBulletinById(_x2) {
      return _getBulletinById.apply(this, arguments);
    }

    return getBulletinById;
  }(),
  insertBulletin: function () {
    var _insertBulletin = (0, _asyncToGenerator2.default)(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee3(_ref3, form) {
      var commit, bulletinFiles, resBulletin, questions, resSurvey, resBulletinSurvey;
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              commit = _ref3.commit;
              bulletinFiles = [];

              if (form.fileList.length !== 0 && form.fileList) {
                form.fileList.forEach(function (item) {
                  bulletinFiles.push({
                    file_name: item.nameSave,
                    url: item.url
                  });
                });
              }

              _context3.next = 5;
              return _apolloClient.apolloClient.mutate({
                mutation: _bulletinMutation.ADD_BULLETIN,
                variables: {
                  title: form.title,
                  content: form.content,
                  push_notification: form.push_notification,
                  attach_files: bulletinFiles,
                  categoryId: form.categoryId,
                  publish_at: form.publish_at
                }
              });

            case 5:
              resBulletin = _context3.sent;

              if (!resBulletin.data) {
                _context3.next = 31;
                break;
              }

              if (!(form.survey.questions.length !== 0 && form.survey.question && form.survey.questions[0].content)) {
                _context3.next = 28;
                break;
              }

              questions = [];
              form.survey.questions.map(function (item) {
                if (item.content) {
                  return questions.push({
                    'content': item.content
                  });
                }
              });

              if (!(questions.length !== 0)) {
                _context3.next = 26;
                break;
              }

              _context3.next = 13;
              return _apolloClient.apolloClient.mutate({
                mutation: _bulletinMutation.INSERT_SURVEY_ONE,
                variables: {
                  choice_type: form.survey.radio,
                  question: form.survey.question,
                  is_public_result: form.survey.is_public_result,
                  data: questions
                }
              });

            case 13:
              resSurvey = _context3.sent;

              if (!resSurvey.data) {
                _context3.next = 25;
                break;
              }

              _context3.next = 17;
              return _apolloClient.apolloClient.mutate({
                mutation: _bulletinMutation.INSERT_BULLETIN_SURVEY_ONE,
                variables: {
                  bulletin_id: resBulletin.data.insert_bulletin_one.id,
                  survey_id: resSurvey.data.insert_survey_one.id
                }
              });

            case 17:
              resBulletinSurvey = _context3.sent;

              if (!resBulletinSurvey.data) {
                _context3.next = 22;
                break;
              }

              return _context3.abrupt("return", resBulletinSurvey.data);

            case 22:
              throw resSurvey.errors[0].message;

            case 23:
              _context3.next = 26;
              break;

            case 25:
              throw resSurvey.errors[0].message;

            case 26:
              _context3.next = 29;
              break;

            case 28:
              return _context3.abrupt("return", resBulletin.data);

            case 29:
              _context3.next = 32;
              break;

            case 31:
              throw resBulletin.errors[0].message;

            case 32:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));

    function insertBulletin(_x3, _x4) {
      return _insertBulletin.apply(this, arguments);
    }

    return insertBulletin;
  }(),
  updateBulletin: function () {
    var _updateBulletin = (0, _asyncToGenerator2.default)(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee4(_ref4, form) {
      var commit, bulletinFiles, res, deleteSurveyIds, bulletinSurveyVariables, resSurvey;
      return regeneratorRuntime.wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              commit = _ref4.commit;
              bulletinFiles = [];

              if (form.fileList.length !== 0 && form.fileList) {
                form.fileList.forEach(function (item) {
                  bulletinFiles.push({
                    bulletin_id: form.id,
                    file_name: item.nameSave,
                    url: item.url
                  });
                });
              }

              _context4.next = 5;
              return _apolloClient.apolloClient.mutate({
                mutation: _bulletinMutation.UPDATE_BULLETIN,
                variables: {
                  id: form.id,
                  title: form.title,
                  content: form.content,
                  publish_at: form.publish_at,
                  push_notification: form.push_notification,
                  categoryId: form.categoryId,
                  objects: bulletinFiles
                }
              });

            case 5:
              res = _context4.sent;

              if (!res.data) {
                _context4.next = 18;
                break;
              }

              deleteSurveyIds = [];

              if (form.originalSurvey && form.originalSurvey.id) {
                deleteSurveyIds.push(form.originalSurvey.id);
              }

              console.log('deleteSurveyIds', deleteSurveyIds);
              bulletinSurveyVariables = [];

              if (form.survey && form.survey.question && form.survey.questions && form.survey.questions.length > 0) {
                bulletinSurveyVariables.push({
                  'bulletin_id': form.id,
                  'survey': {
                    'data': {
                      'choice_type': form.survey.choice_type,
                      'question': form.survey.question,
                      'is_public_result': form.survey.is_public_result,
                      'survey_answers': {
                        'data': form.survey.questions.map(function (item) {
                          return {
                            'content': item.content
                          };
                        })
                      }
                    }
                  }
                });
              }

              _context4.next = 14;
              return _apolloClient.apolloClient.mutate({
                mutation: _bulletinMutation.REINSERT_BULLETIN_SURVEY,
                variables: {
                  delete_survey_ids: deleteSurveyIds,
                  bulletin_id: form.id,
                  insert_bulletin_survey: bulletinSurveyVariables
                }
              });

            case 14:
              resSurvey = _context4.sent;
              return _context4.abrupt("return", resSurvey.data);

            case 18:
              throw res.errors[0].message;

            case 19:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));

    function updateBulletin(_x5, _x6) {
      return _updateBulletin.apply(this, arguments);
    }

    return updateBulletin;
  }(),
  getBulletinCategories: function () {
    var _getBulletinCategories = (0, _asyncToGenerator2.default)(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee5(_ref5) {
      var commit, res;
      return regeneratorRuntime.wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              commit = _ref5.commit;
              _context5.next = 3;
              return _apolloClient.apolloClient.query({
                query: _bulletinQuery.GET_BULLETIN_CATEGORIES
              });

            case 3:
              res = _context5.sent;

              if (!res.data) {
                _context5.next = 9;
                break;
              }

              commit('CREATE_BULLETIN_CATEGORIES_LIST', res.data.bulletin_categories);
              return _context5.abrupt("return", res.data.bulletin);

            case 9:
              throw res.errors[0].message;

            case 10:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5);
    }));

    function getBulletinCategories(_x7) {
      return _getBulletinCategories.apply(this, arguments);
    }

    return getBulletinCategories;
  }(),
  insertBulletinCategories: function () {
    var _insertBulletinCategories = (0, _asyncToGenerator2.default)(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee6(_ref6, data) {
      var commit, res;
      return regeneratorRuntime.wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              commit = _ref6.commit;
              _context6.next = 3;
              return _apolloClient.apolloClient.mutate({
                mutation: _bulletinMutation.ADD_BULLETIN_CATEGORIES,
                variables: {
                  name: data
                }
              });

            case 3:
              res = _context6.sent;

              if (!res.data) {
                _context6.next = 8;
                break;
              }

              return _context6.abrupt("return", res.data);

            case 8:
              throw res.errors[0].message;

            case 9:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6);
    }));

    function insertBulletinCategories(_x8, _x9) {
      return _insertBulletinCategories.apply(this, arguments);
    }

    return insertBulletinCategories;
  }(),
  updateBulletinCategories: function () {
    var _updateBulletinCategories = (0, _asyncToGenerator2.default)(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee7(_ref7, data) {
      var commit, res;
      return regeneratorRuntime.wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              commit = _ref7.commit;
              _context7.next = 3;
              return _apolloClient.apolloClient.mutate({
                mutation: _bulletinMutation.UPDATE_BULLETIN_CATEGORIES_BY_ID,
                variables: {
                  id: data.id,
                  name: data.name
                }
              });

            case 3:
              res = _context7.sent;

              if (!res.data) {
                _context7.next = 8;
                break;
              }

              return _context7.abrupt("return", res.data);

            case 8:
              throw res.errors[0].message;

            case 9:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7);
    }));

    function updateBulletinCategories(_x10, _x11) {
      return _updateBulletinCategories.apply(this, arguments);
    }

    return updateBulletinCategories;
  }(),
  updateBulletinAndDeleteSurveyById: function () {
    var _updateBulletinAndDeleteSurveyById = (0, _asyncToGenerator2.default)(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee8(_ref8, data) {
      var commit, res, resSurvey;
      return regeneratorRuntime.wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              commit = _ref8.commit;
              _context8.next = 3;
              return _apolloClient.apolloClient.mutate({
                mutation: _bulletinMutation.UPDATE_BULLETIN_BY_ID,
                variables: {
                  bulletinId: data.bulletinId
                }
              });

            case 3:
              res = _context8.sent;

              if (!res.data) {
                _context8.next = 19;
                break;
              }

              if (!(data.survey_id.length !== 0 && data.survey_answer_id.length !== 0)) {
                _context8.next = 16;
                break;
              }

              _context8.next = 8;
              return _apolloClient.apolloClient.mutate({
                mutation: _bulletinMutation.DELETE_SURVEY,
                variables: {
                  survey_id: data.survey_id,
                  survey_answer_id: data.survey_answer_id
                }
              });

            case 8:
              resSurvey = _context8.sent;

              if (!resSurvey.data) {
                _context8.next = 13;
                break;
              }

              return _context8.abrupt("return", resSurvey.data);

            case 13:
              throw resSurvey.errors[0].message;

            case 14:
              _context8.next = 17;
              break;

            case 16:
              return _context8.abrupt("return", res.data);

            case 17:
              _context8.next = 20;
              break;

            case 19:
              throw res.errors[0].message;

            case 20:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8);
    }));

    function updateBulletinAndDeleteSurveyById(_x12, _x13) {
      return _updateBulletinAndDeleteSurveyById.apply(this, arguments);
    }

    return updateBulletinAndDeleteSurveyById;
  }(),
  deleteCategoryAndUpdateBulletinCategoryById: function () {
    var _deleteCategoryAndUpdateBulletinCategoryById = (0, _asyncToGenerator2.default)(
    /*#__PURE__*/
    regeneratorRuntime.mark(function _callee9(_ref9, categoryId) {
      var commit, res;
      return regeneratorRuntime.wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              commit = _ref9.commit;
              _context9.next = 3;
              return _apolloClient.apolloClient.mutate({
                mutation: _bulletinMutation.DELETE_CATEGORY_AND_UPDATE_BULLETIN_CATEGORY_BY_ID,
                variables: {
                  category_id: categoryId
                }
              });

            case 3:
              res = _context9.sent;

              if (!res.data) {
                _context9.next = 8;
                break;
              }

              return _context9.abrupt("return", res.data);

            case 8:
              throw res.errors[0].message;

            case 9:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9);
    }));

    function deleteCategoryAndUpdateBulletinCategoryById(_x14, _x15) {
      return _deleteCategoryAndUpdateBulletinCategoryById.apply(this, arguments);
    }

    return deleteCategoryAndUpdateBulletinCategoryById;
  }()
};
var _default = {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions
};
exports.default = _default;